import { User } from 'lucide-react';

interface LandingNavbarProps {
  onLogoClick: () => void;
  isLoggedIn?: boolean;
  userName?: string;
  onProfileClick?: () => void;
  onMyTicketsClick?: () => void;
  onSettingsClick?: () => void;
  onLogoutClick?: () => void;
  onLoginClick?: () => void;
  className?: string;
}

export const LandingNavbar = ({ 
  onLogoClick,
  isLoggedIn = false,
  onProfileClick,
  onMyTicketsClick,
  onSettingsClick,
  onLoginClick,
  className = ""
}: LandingNavbarProps) => {
  return (
    <nav className={`bg-white border-b border-[#E5E7EB] sticky top-0 z-50 shadow-sm ${className}`}>
      <div className="max-w-[1440px] mx-auto px-8 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button onClick={onLogoClick} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 bg-[#FF6A2A] rounded-[14px] flex items-center justify-center">
              <span className="text-white font-bold text-lg">M</span>
            </div>
            <span className="text-xl font-semibold text-[#111827]">Mexmo</span>
          </button>
          
          {/* Center Navigation Links */}
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={onLogoClick} className="text-[#111827] hover:text-[#FF6A2A] font-medium transition-colors">
              Viajar
            </button>
            <button onClick={onMyTicketsClick} className="text-[#6B7280] hover:text-[#111827] font-medium transition-colors">
              Boletos
            </button>
            <button onClick={onSettingsClick} className="text-[#6B7280] hover:text-[#111827] font-medium transition-colors">
              Configuración
            </button>
          </div>

          {/* Right Side - Conditional based on login state */}
          {isLoggedIn ? (
            <button
              onClick={onProfileClick}
              className="w-8 h-8 bg-[#F7F8FA] rounded-full flex items-center justify-center hover:bg-[#E5E7EB] transition-colors"
            >
              <User className="w-4 h-4 text-[#6B7280]" />
            </button>
          ) : (
            <button
              onClick={onLoginClick}
              className="px-6 py-2.5 bg-[#FF6A2A] text-white font-medium rounded-[14px] hover:bg-[#C2410C] transition-colors"
            >
              Iniciar sesión
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};